export enum AccountType {
  PASSENGER = "passenger",
  EXECUTIVE_ASSISTANT = "executive_assistant",
  TRAVEL_MANAGER = "travel_manager",
  DRIVER = "driver",
  OPERATOR = "operator",
  USER_ACCOUNT = "user_account",
}

/**
 * The account types that belong in the client portal rather than the operator dashboard.
 * The profile payload surfaces Executive Assistant as either the enum value or the short
 * "ea" alias, so both are matched.
 *
 * NOTE: callers read `profile.accountMetadata.type`, which is NOT the source of truth — it's a
 * copy of the authoritative `registered_as` column and it CAN drift from it. Only use this to
 * pick presentation, never to grant or deny access.
 */
export const CLIENT_ACCOUNT_TYPES: string[] = [
  AccountType.PASSENGER,
  AccountType.EXECUTIVE_ASSISTANT,
  AccountType.TRAVEL_MANAGER,
  "ea",
];

/**
 * True only when the account type is positively known to be a client one. An unknown, missing or
 * operator type returns false, so anything we can't confidently identify keeps its existing
 * behaviour — the fail-safe direction.
 */
export const isClientAccountType = (type?: string | null): boolean => !!type && CLIENT_ACCOUNT_TYPES.includes(type);
